import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const testimonials = [
  {
    id: 1,
    name: 'Anonymous User',
    age: 32,
    location: 'Mumbai',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_12f477032-1763301009691.png",
    avatarAlt: 'Professional woman with long brown hair wearing white blouse in office setting with natural lighting',
    rating: 5,
    text: `Finally found a platform where I can be myself without fear of judgment. The privacy controls are excellent, and I've made some genuine connections here.`, date: 'January 2026'
  },
  {
    id: 2,
    name: 'Discreet Member', age: 28, location: 'Delhi', avatar: "https://images.unsplash.com/photo-1711789493933-08c0c95d3907", avatarAlt: 'Young man with short dark hair wearing casual blue shirt smiling outdoors with blurred background', rating: 5, text: `The anonymity features are top-notch. I appreciate being able to blur my photos and control who can message me. It's exactly what I was looking for.`,
    date: 'December 2025'
  },
  {
    id: 3,
    name: 'Private User',
    age: 35,
    location: 'Bangalore',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_144056239-1763296227528.png",
    avatarAlt: 'Mature man with beard and glasses wearing dark shirt in professional indoor setting',
    rating: 4,
    text: `Great platform for discreet connections. The messaging system is secure, and I love the disappearing messages feature. Highly recommended!`,
    date: 'January 2026'
  },
  {
    id: 4,
    name: 'Anonymous Member',
    age: 30,
    location: 'Pune',
    avatar: "https://images.unsplash.com/photo-1645143077850-f2b15914f4e0",
    avatarAlt: 'Woman with curly hair wearing red top smiling warmly in bright indoor environment',
    rating: 5,
    text: `I was skeptical at first, but this platform exceeded my expectations. The community is respectful, and the privacy features give me peace of mind.`,
    date: 'December 2025'
  }];


  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials?.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials?.length]);

  const handlePrevious = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  const handleNext = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev + 1) % testimonials?.length);
  };

  const handleDotClick = (index) => {
    setIsAutoPlaying(false);
    setCurrentIndex(index);
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted/30">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-3 md:mb-4">
            What Our Members Say
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Real experiences from our anonymous community members
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-card rounded-xl p-6 md:p-8 lg:p-10 shadow-warm-lg">
            <div className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8">
              <div className="flex-shrink-0">
                <div className="relative w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28">
                  <Image
                    src={testimonials?.[currentIndex]?.avatar}
                    alt={testimonials?.[currentIndex]?.avatarAlt}
                    className="w-full h-full rounded-full object-cover blur-sm" />

                  <div className="absolute inset-0 rounded-full bg-gradient-to-br from-primary/20 to-secondary/20" />
                </div>
              </div>

              <div className="flex-1 text-center md:text-left">
                <div className="flex items-center justify-center md:justify-start gap-1 mb-3 md:mb-4">
                  {[...Array(5)]?.map((_, i) =>
                  <Icon
                    key={i}
                    name={i < testimonials?.[currentIndex]?.rating ? 'Star' : 'Star'}
                    size={16}
                    className="md:w-5 md:h-5"
                    color={i < testimonials?.[currentIndex]?.rating ? 'var(--color-warning)' : 'var(--color-muted-foreground)'} />

                  )}
                </div>

                <p className="text-base md:text-lg text-foreground leading-relaxed mb-4 md:mb-6 italic">
                  "{testimonials?.[currentIndex]?.text}"
                </p>

                <div className="space-y-1">
                  <div className="flex items-center justify-center md:justify-start gap-2">
                    <h4 className="text-sm md:text-base font-caption font-semibold text-foreground">
                      {testimonials?.[currentIndex]?.name}
                    </h4>
                    <span className="text-xs md:text-sm text-muted-foreground">
                      • {testimonials?.[currentIndex]?.age} years
                    </span>
                  </div>
                  <div className="flex items-center justify-center md:justify-start gap-2 text-xs md:text-sm text-muted-foreground">
                    <Icon name="MapPin" size={14} />
                    <span>{testimonials?.[currentIndex]?.location}</span>
                    <span>•</span>
                    <span>{testimonials?.[currentIndex]?.date}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={handlePrevious}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-6 w-10 h-10 md:w-12 md:h-12 bg-card rounded-full shadow-warm-lg flex items-center justify-center hover:bg-muted transition-smooth"
            aria-label="Previous testimonial">

            <Icon name="ChevronLeft" size={20} className="md:w-6 md:h-6" />
          </button>

          <button
            onClick={handleNext}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-6 w-10 h-10 md:w-12 md:h-12 bg-card rounded-full shadow-warm-lg flex items-center justify-center hover:bg-muted transition-smooth"
            aria-label="Next testimonial">

            <Icon name="ChevronRight" size={20} className="md:w-6 md:h-6" />
          </button>

          <div className="flex items-center justify-center gap-2 mt-6 md:mt-8">
            {testimonials?.map((_, index) =>
            <button
              key={index}
              onClick={() => handleDotClick(index)}
              className={`w-2 h-2 md:w-2.5 md:h-2.5 rounded-full transition-smooth ${
              index === currentIndex ?
              'bg-primary w-6 md:w-8' : 'bg-muted-foreground/30 hover:bg-muted-foreground/50'}`
              }
              aria-label={`Go to testimonial ${index + 1}`} />

            )}
          </div>
        </div>
      </div>
    </section>);

};

export default TestimonialsSection;